import ReceiptsPage from "./ReceiptsPage";
export default ReceiptsPage;
